export function getAttributeInputType(attributeName = "") {
  const normalizedName = String(attributeName || "").trim().toLowerCase();

  if (normalizedName.includes("tempo esperado") || normalizedName.includes("tempo gasto") || normalizedName.includes("progresso")) {
    return "number";
  }

  if (normalizedName.includes("horas trabalhadas") || normalizedName.includes("diariamente")) {
    return "daily-hours";
  }

  if (normalizedName.includes("data de início") || normalizedName.includes("data de fim") || normalizedName.includes("data de início") || normalizedName.includes("data de fim")) {
    return "date";
  }

  return "text";
}

export function parseDailyHoursValue(value) {
  if (!value) {
    return [];
  }

  const entries = String(value)
    .split(/;|,|\n/)
    .map((entry) => entry.trim())
    .filter(Boolean)
    .map((entry) => {
      const match = entry.match(/^(\d{2}\/\d{2}\/\d{4})\s*-\s*([0-9]+(?:[.,][0-9]+)?)\s*(?:horas\s+trabalhadas|horas)?$/i);

      if (!match) {
        return null;
      }

      return {
        date: match[1],
        hours: String(match[2]).replace(",", "."),
      };
    })
    .filter(Boolean);

  return entries;
}

export function serializeDailyHoursValue(values) {
  if (!Array.isArray(values)) {
    return "";
  }

  return values
    .filter((entry) => entry?.date)
    .map((entry) => `${entry.date} - ${entry.hours}`)
    .join(", ");
}
